import { TableProvider } from "./providers";
import { MainComponent } from "./components";

export function SerialNumberPage() {
  return (
    <TableProvider>
      <MainComponent />
    </TableProvider>
  );
}
